export function getAnniversaryWindow(anniversaryDate?: Date | null): {
  startsAt: Date | null;
  endsAt: Date | null;
} {
  if (!anniversaryDate) {
    return { startsAt: null, endsAt: null };
  }
  const base = new Date(anniversaryDate);

  const startsAt = new Date(base);
  startsAt.setDate(base.getDate() - 28);

  const endsAt = new Date(base);
  endsAt.setDate(base.getDate() + 7);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (startsAt < today) {
    startsAt.setFullYear(startsAt.getFullYear() + 1);
    endsAt.setFullYear(endsAt.getFullYear() + 1);
  }

  startsAt.setHours(0, 0, 0, 0);

  endsAt.setHours(23, 59, 59, 999);

  return { startsAt, endsAt };
}
